module.exports = __webpack_public_path__ + "img/cert1.a10deb65.png";